require('./js/animation.js')
import LocomotiveScroll from "locomotive-scroll";

const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
if (!mediaQuery || !mediaQuery.matches) {
  const locomotiveScroll = new LocomotiveScroll({
    lenisOptions: {
      lerp: 1,
      duration: 0.4
    }
  });
}
